import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "@/components/shared/Toast";
import { useFirstWin } from "@/lib/onboarding";

/**
 * First win 1b (Olivia, 21 Oct 2026): the account's first export says the file is ready and offers
 * Share (the lilia:open-share event opens the editor's share drawer). Later exports stay silent.
 */
export function useFirstExportToast() {
  const { t } = useTranslation("editor");
  const { showToast } = useToast();
  const firstWin = useFirstWin("first-export");
  return useCallback(
    (format: string) => {
      void firstWin().then((first) => {
        if (!first) return;
        const kind = format.toUpperCase();
        const key = kind === "PDF" ? "pdf" : kind === "DOCX" ? "docx" : kind === "LATEX" ? "latex" : "other";
        showToast(t(`firstWin.${key}`), "success", {
          durationMs: 10_000,
          action: {
            key: "share",
            label: t("firstWin.share"),
            onClick: () => window.dispatchEvent(new CustomEvent("lilia:open-share")),
          },
        });
      });
    },
    [firstWin, showToast, t],
  );
}
